import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {PointTemplatesSingleVoyageLazy} from "@containers/singleVoyage/pointTemplates/PointTemplatesSingleVoyage.lazy";

const PointTemplatesSingleVoyagePage = () => {

	return (
		<PageLayout>
			<Suspense
				fallback={<SpinnerCustom/>}
			>
				<PointTemplatesSingleVoyageLazy/>
			</Suspense>
		</PageLayout>
	);
};

export default PointTemplatesSingleVoyagePage;